<template>
  <div class="min-h-screen bg-gray-100">
    <Navbar />
    <div class="w-3/4 pt-24 mx-auto">
      <Table />
    </div>
    <!-- <button
      type="button"
      class="btn"
      @click="showModal"
    >
      Open Modal!
    </button> -->

    <Modal
      v-show="isModalVisible"
      @close="closeModal"
    />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Table from "@/components/Table";
import Modal from "@/components/Modal";

export default {
  components: {
    Navbar,
    Table,
    Modal
  },
  data () {
    return {
      isModalVisible: false,
    };
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    }
  },
}
</script>

<style scoped></style>